import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewNotFound() {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DOCUMENT_NOT_FOUND"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "view-not-found-message",
      message: "view.notFound"
    })]
  });
}